// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.nest-menu{\n  height: 60px !important;\n  line-height: 60px !important;\n  font-size: 15px !important;\n}\n.animation-right {\n  width: 50px;\n  height: 50px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
